import React, { useId } from 'react';

import type { SliderValue } from './calculator';

import classes from './styles.module.scss';

export interface SliderRange {
    max: number;
    tickInterval: number;
}

interface StepSliderProps {
    label: string;
    value: SliderValue;
    range: SliderRange;
    onChange: (value: number) => void;
    'data-i18n-key'?: string;
}

function StepSlider({
    label,
    value,
    range: { max, tickInterval },
    onChange,
    'data-i18n-key': i18nKey,
}: StepSliderProps) {
    const inputId = useId();
    const position = value ?? 0;
    const tickCount = Math.floor(max / tickInterval) + 1;
    const ticks = Array.from({ length: tickCount }, (_, index) => index * tickInterval);

    return (
        <div className={classes.field}>
            <label htmlFor={inputId} className={classes.fieldLabel} data-i18n-key={i18nKey}>
                {label}
            </label>
            <div
                className={classes.slider}
                style={{ '--slider-fraction': position / max } as React.CSSProperties}
            >
                <output htmlFor={inputId} className={classes.sliderValue}>
                    {position}
                </output>
                <input
                    id={inputId}
                    type="range"
                    min={0}
                    max={max}
                    step={1}
                    value={position}
                    onChange={(event) => onChange(Number(event.target.value))}
                />
                <div className={classes.sliderTicks} aria-hidden="true">
                    {ticks.map((tick) => (
                        <span
                            key={tick}
                            style={{ '--slider-fraction': tick / max } as React.CSSProperties}
                        >
                            {tick}
                        </span>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default StepSlider;
